import earnCreditModalTemplate from 'services/modal/earnCredit/earnCreditModal.html';

function Ctrl($scope, $uibModal, utilsService, metaTagService, jsSdkReferral, jsSdkSettings) {
  metaTagService.set({
    title: 'Earn Credit | Tablelist',
    description: 'Earn free credit by inviting your friends to join your VIP tables in Boston, New York City, Las Vegas, and San Francisco',
    facebookTitle: 'Get $25 for every friend you invite to Tablelist.',
    facebookDescription: 'Use Tablelist for a better night out. Life is a celebration, and finding the party has never been easier.'
  });

  if ($scope.currentUser && $scope.currentUser.id) {
    getReferrals();
  }

  $scope.learnMore = function() {
    $uibModal.open({
      template: earnCreditModalTemplate,
      windowClass: 'earnCreditModal',
      controller: 'earnCreditModalCtrl'
    });
  };

  $scope.scrollTo = function(target) {
    utilsService.scrollTo(target, 110, 500);
  };

  $scope.referralGetCredit = 25;
  $scope.referralGiveCredit = 25;

  const referralCode = ($scope.currentUser && $scope.currentUser.referralCode) ? $scope.currentUser.referralCode : '';

  $scope.shareURL = utilsService.createUrl(`/invite/${referralCode}`);

  jsSdkSettings.readConfig()
    .then(function success(resp) {
      $scope.referralGetCredit = resp.referralGetCredit;
      $scope.referralGiveCredit = resp.referralGiveCredit;

      $scope.facebookLink = utilsService.facebookLink($scope.shareURL);
      $scope.twitterLink = utilsService.twitterLink($scope.shareURL, `Join @Tablelist with my promo code to get $${resp.referralGiveCredit} in credit at your favorite clubs and lounges.`);
    });

  function getReferrals() {
    jsSdkReferral.listByUserId($scope.currentUser.id).then(function success(response) {
      $scope.referrals = response;
    });
  }
}

Ctrl.$inject = [
  '$scope',
  '$uibModal',
  'utilsService',
  'metaTagService',
  'jsSdk.referral',
  'jsSdk.settings'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/earnCredit/earnCreditCtrl.js